import { Component, OnInit } from '@angular/core';
import {CardImagesmaster} from "../models/card_imagesmaster";
import {CardImagesService} from "../services/card_images.service";
import {Router} from "@angular/router";
import {environment} from "../../../environments/environment";
declare var $ :any;
declare var bootbox: any;
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-card_imageslist',
  templateUrl: './card_imageslist.component.html'
})
export class CardImageslistComponent implements OnInit {

    p: number[] = [];
    searchText: string = ''; 
    card_id: number = 0;
    card_imageslist:CardImagesmaster[];

    constructor(
        private cardImagesService:CardImagesService,
        private router:Router,
        private activatedRoute: ActivatedRoute
    ) { }

    ngOnInit() {
        console.log(this.activatedRoute)
        this.activatedRoute.params.subscribe(params => {
            if(params['id']) {
                this.card_id = params['id'];
                console.log("CardId======>",this.card_id); // Print the parameter to the console.
            }
        });

        this.getCardImages(0,{sortColumn: 'card_images_id', sortDirection:'desc'});
        // $(document).ready(function() {
        //     $("#datatable").DataTable();
        // });
    }

    onSorted($event){
        this.getCardImages(0,$event);
    }

    getCardImages=function(pageId,criteria: CardImagesListSearchCriteria){
        this.cardImagesService.getCardImagesList(pageId,this.searchText,this.card_id).then(data => {
            console.log("CardImagesList =======>",data);
            this.card_imageslist = data['data']['data'];
            this.totaloffset = data['data'].Totaloffset;
            this.itemsperpage = data['data'].ItemsPerPage;
            this.SortCardImages(criteria);     
        });
    }

    SortCardImages(criteria: CardImagesListSearchCriteria): CardImagesmaster[] {
        return this.card_imageslist.sort((a,b) => {
          if(criteria.sortDirection === 'desc'){
            if (a[criteria.sortColumn] < b[criteria.sortColumn]) {
                return 1
            } else {
                return 0
            }
          }
          else {
            if (a[criteria.sortColumn] > b[criteria.sortColumn]) {
                return 1
            } else {
                return 0
            }
          }
        });
    }

    viewCardImages(card_images_id){
        this.router.navigate(['/card_images/',card_images_id]);
    }

    deleteCardImageCall(card_images_id,i){
        this.cardImagesService.deleteCardImageCall(card_images_id).then(data => {
            console.log(data['code'])
            if(data['code'] === 200){
                $.toast({heading: 'Success', text: data['message'], position: 'top-right', showHideTransition: 'slide', icon: 'success'});
                this.getCardImages(0,{sortColumn: 'card_name', sortDirection:'desc'});
                // this.router.navigate(['/card_images']);
            }else{
                $.toast({heading: 'Warning', text: data['message'], position: 'top-right', showHideTransition: 'slide', icon: 'warning'});
            }
        }).catch(err => {
            if(err['code'] != 200){
                $.toast({heading: 'Error', text: err['message'], position: 'top-right', showHideTransition: 'slide', icon: 'error'});
            }else{
                $.toast({heading: 'Error', text: 'Server error! Please try again later', position: 'top-right', showHideTransition: 'slide', icon: 'error'});
            }
        });
    }

    deleteCardConfirm(card_images_id,i){
        var _this = this;
        bootbox.confirm({
            message: "Are you sure you want to delete this record?",
            buttons: {
                confirm: {label: 'Yes',className: 'btn-success btn-flat'},
                cancel: {label: 'No',className: 'btn-default btn-flat'}
            },
            callback: function (result) {
                if(result) {
                    _this.deleteCardImageCall(card_images_id,i);
                }
            }
        });
    }

}

export class CardImagesListSearchCriteria {
    sortColumn: string;
    sortDirection: string;
}



// WEBPACK FOOTER //
// /home/sotsys211/work/src/ecard_new/backend/src/app/card_imagesmaster/card_imageslist/card_imageslist.component.ts